import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/web.timers.js";
import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, unref as _unref, Fragment as _Fragment, renderSlot as _renderSlot, renderList as _renderList, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-950e7442"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0,
  style: {
    "position": "absolute",
    "z-index": "1000, top: 0, left: 0"
  },
  "class": "flex flex-row px-md items-center justify-center w-full h-full"
};
var _hoisted_2 = {
  key: 3
};
var _hoisted_3 = {
  key: 0,
  "class": "font-bold"
};
var _hoisted_4 = {
  key: 1,
  "class": "PBSelect__multi-options"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  "class": "PBSelect__dropdown scroller shadow-lg"
};
var _hoisted_7 = {
  key: 0,
  "class": "PBSelect__tabs"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  key: 1,
  "class": "PBSelect__dropdown-head"
};
var _hoisted_10 = {
  key: 2,
  "class": "PBSelect__search"
};
var _hoisted_11 = {
  key: 0,
  "class": "PBSelect__list-title"
};
var _hoisted_12 = {
  key: 1,
  "class": "PBSelect__list PBSelect__list--top"
};
var _hoisted_13 = ["onClick"];
var _hoisted_14 = {
  key: 2,
  "class": "PBSelect__list-title"
};
var _hoisted_15 = {
  key: 3,
  "class": "PBSelect__list"
};
var _hoisted_16 = ["onClick"];
var _hoisted_17 = {
  key: 2,
  "class": "flex PBSelect__default-option items-center"
};
var _hoisted_18 = {
  key: 4,
  "class": "p-md text-center"
};
import isDeepEqual from "lodash/isEqual";
import { onMounted } from "vue";

import { ref, computed, watch, nextTick } from 'vue';
import { onClickOutside } from '@vueuse/core';
export default {
  __name: 'PBSelect',
  props: {
    nestedKey: {
      type: String,
      "default": ""
    },
    groupBy: {
      type: String,
      "default": ""
    },
    label: {
      type: String,
      "default": ""
    },
    placeholder: {
      type: String,
      "default": ""
    },
    error: {
      type: String,
      "default": ""
    },
    disabled: Boolean,
    loading: Boolean,
    multi: Boolean,
    topListTitle: {
      type: String,
      "default": ""
    },
    addNewButtonText: {
      type: String,
      "default": ""
    },
    tooltip: {
      type: String,
      "default": ""
    },
    modelValue: {
      type: [Object, Array],
      "default": null
    },
    options: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    optionsSort: {
      type: [Boolean, Function],
      "default": false
    },
    valueKey: {
      type: String,
      "default": "value"
    },
    textKey: {
      type: String,
      "default": "text"
    },
    topList: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    disabledOption: {
      type: Function,
      "default": function _default() {
        return false;
      }
    },
    showSearch: {
      type: Boolean,
      "default": true
    }
  },
  emits: ["update:modelValue"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var selectedOption = ref([]);
    var searchQuery = ref("");
    var selectedGroup = ref("all");
    var selectRef = ref(null);
    var searchInputRef = ref(null);
    var selectTabsRef = ref(null);
    var isDropdown = ref(false);
    if (!props.multi) {
      setSelectedOption(props.modelValue);
    }
    var selectedOptions = computed(function () {
      var result = props.options;
      if (selectedOption.value) {
        if (selectedOption.value.options) {
          result = selectedOption.value.options;
        }
        if (selectedOption.value.nested) {
          var parent = result.find(function (option) {
            return option[props.nestedKey] === selectedOption.value[props.nestedKey];
          });
          if (parent !== null && parent !== void 0 && parent.options) {
            result = parent.options;
          }
        }
      }
      if (props.topList.length) {
        var list = props.topList.map(function (item) {
          return item[props.valueKey];
        });
        result = result.filter(function (option) {
          return !list.includes(option[props.valueKey]);
        });
      }
      return result;
    });
    var filteredTopList = computed(function () {
      var result = props.topList;
      var searchKey = props.textKey;
      if (!searchQuery.value) {
        return result;
      }
      return result.filter(function (option) {
        var _option$searchBy;
        var formattedSearchQuery = searchQuery.value.toLowerCase();
        if (option !== null && option !== void 0 && (_option$searchBy = option.searchBy) !== null && _option$searchBy !== void 0 && _option$searchBy.length) {
          var _result = [];
          if (option.searchBy.length > 1) {
            var _iterator = _createForOfIteratorHelper(option.searchBy),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var key = _step.value;
                if (option[key]) {
                  _result.push(option[key].toLowerCase().indexOf(formattedSearchQuery) > -1);
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            return _result.filter(Boolean)[0];
          }
          searchKey = option.searchBy[0];
          return option[searchKey].toLowerCase().indexOf(formattedSearchQuery) > -1;
        }
        var isValue = option[props.valueKey].toLowerCase().indexOf(formattedSearchQuery) > -1;
        var isText = option[searchKey].toLowerCase().indexOf(formattedSearchQuery) > -1;
        return isValue || isText;
      });
    });
    var filteredOptions = computed(function () {
      var result = selectedOptions.value;
      var searchKey = props.textKey;
      if (selectedGroup.value && selectedGroup.value !== "all") {
        result = result.filter(function (option) {
          return option[props.groupBy] === selectedGroup.value;
        });
      }
      if (!searchQuery.value) {
        return result;
      }
      var formattedSearchQuery = searchQuery.value.toLowerCase();
      result = result.filter(function (option) {
        if (option.searchBy && option.searchBy.length) {
          var _result2 = [];
          if (option.searchBy.length > 1) {
            var _iterator2 = _createForOfIteratorHelper(option.searchBy),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var key = _step2.value;
                if (option[key]) {
                  _result2.push(option[key].toLowerCase().indexOf(formattedSearchQuery) > -1);
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
            return _result2.filter(Boolean)[0];
          }
          searchKey = option.searchBy[0];
          return option[searchKey] && option[searchKey].toLowerCase().indexOf(formattedSearchQuery) > -1;
        }
        var isValue = option[props.valueKey] && option[props.valueKey].toLowerCase().indexOf(formattedSearchQuery) > -1;
        var isText = option[searchKey] && option[searchKey].toLowerCase().indexOf(formattedSearchQuery) > -1;
        return isValue || isText;
      });
      if (!props.optionsSort) {
        return result;
      }
      return result.sort(props.optionsSort(formattedSearchQuery));
    });
    var groups = computed(function () {
      var groups = [];
      var _iterator3 = _createForOfIteratorHelper(selectedOptions.value),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var option = _step3.value;
          if (option.groupBy && !groups.includes(option[option.groupKey])) {
            groups.push(option[option.groupKey]);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      if (groups.length) {
        groups.unshift("all");
      }
      return groups;
    });
    function setSelectedOption(option) {
      if (props.multi) {
        var index = selectedOption.value.findIndex(function (item) {
          return item[props.valueKey] === option[props.valueKey];
        });
        index === -1 ? selectedOption.value.push(option) : selectedOption.value.splice(index, 1);
      } else {
        selectedOption.value = option;
      }
      searchQuery.value = "";
    }
    function selectOption(option) {
      if (isDeepEqual(option, selectedOption.value) || props.disabledOption(option)) {
        return;
      }
      setSelectedOption(option);
      emit("update:modelValue", selectedOption.value);
      if (option.options) {
        return;
      }
      if (!props.multi) {
        hideDropdown();
      }
    }
    function hideDropdown() {
      isDropdown.value = false;
      setTimeout(function () {
        return searchQuery.value = "";
      }, 250);
    }
    function isActive(option) {
      if (props.multi) {
        return !!selectedOption.value.find(function (item) {
          return item[props.valueKey] === option[props.valueKey];
        });
      }
      return selectedOption.value && selectedOption.value[props.valueKey] === option[props.valueKey];
    }
    function toggleDropdown() {
      if (props.disabled) {
        return;
      }
      isDropdown.value = !isDropdown.value;
    }
    function goBack() {
      resetQueryAndGroup();
      selectedOption.value = null;
      emit("update:modelValue", selectedOption.value);
    }
    function resetQueryAndGroup() {
      searchQuery.value = "";
      selectedGroup.value = "all";
    }
    function selectTab(_, group) {
      selectedGroup.value = group;
    }
    function scroll(direction) {
      if (!selectTabsRef.value) {
        return;
      }
      var left = direction === "left" ? selectTabsRef.value.scrollLeft - 50 : selectTabsRef.value.scrollLeft + 50;
      selectTabsRef.value.scrollTo({
        top: 0,
        left: left,
        behavior: "smooth"
      });
    }
    onClickOutside(selectRef, hideDropdown);
    watch(function () {
      return props.modelValue;
    }, function (value, old) {
      if (isDeepEqual(old, value)) {
        return;
      }
      if (props.multi) {
        selectedOption.value = value;
      } else {
        setSelectedOption(value);
      }
      emit("update:modelValue", value);
      if (value === null) {
        resetQueryAndGroup();
      }
    });
    watch(isDropdown, /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(value) {
        var input;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!value) {
                resetQueryAndGroup();
              }
              if (!(value && props.options.length > 5)) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return nextTick();
            case 4:
              input = searchInputRef.value;
              input === null || input === void 0 ? void 0 : input.focus();
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    onMounted(function () {
      selectedOption.value = props.multi ? [] : props.modelValue;
    });
    return function (_ctx, _cache) {
      var _component_PBIcon = _resolveComponent("PBIcon");
      var _component_Tooltip = _resolveComponent("Tooltip");
      var _component_PBSpinner = _resolveComponent("PBSpinner");
      var _component_PBBadge = _resolveComponent("PBBadge");
      return _openBlock(), _createElementBlock("div", {
        ref_key: "selectRef",
        ref: selectRef,
        "class": _normalizeClass({
          'PBSelect relative': true,
          disabled: __props.disabled
        })
      }, [__props.label ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": "text-base color-white flex items-center leading-none mb-sm cursor-default min-h-[16px]",
        onClick: hideDropdown
      }, [_createTextVNode(_toDisplayString(__props.label) + " ", 1), __props.tooltip ? (_openBlock(), _createBlock(_component_Tooltip, {
        key: 0,
        text: __props.tooltip,
        "class": "ml-md"
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_PBIcon, {
            name: "info",
            w: 16,
            h: 16
          })];
        }),
        _: 1
      }, 8, ["text"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", {
        "class": _normalizeClass({
          PBSelect__trigger: true,
          active: _unref(isDropdown),
          invalid: __props.error
        }),
        onClick: toggleDropdown
      }, [__props.loading ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_PBSpinner, {
        primary: ""
      })])) : _createCommentVNode("", true), _createElementVNode("div", {
        "class": _normalizeClass(["flex items-center w-full h-full text-base font-normal select-none py-[10px] pr-[36px] pl-md", {
          'text-zinc-400': !(!__props.multi && _unref(selectedOption) || __props.multi && _unref(selectedOption).length > 0),
          'text-white': !__props.multi && _unref(selectedOption) || __props.multi && _unref(selectedOption).length > 0
        }])
      }, [!__props.multi && !_unref(selectedOption) || __props.multi && _unref(selectedOption).length === 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode(_toDisplayString(__props.placeholder), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_ctx.$slots['nested-selected-option'] && _unref(selectedOption).nested ? _renderSlot(_ctx.$slots, "nested-selected-option", {
        key: 0,
        option: _unref(selectedOption)
      }) : _ctx.$slots['selected-option'] ? _renderSlot(_ctx.$slots, "selected-option", {
        key: 1,
        option: _unref(selectedOption)
      }) : _ctx.$slots.option ? _renderSlot(_ctx.$slots, "option", {
        key: 2,
        option: _unref(selectedOption)
      }) : (_openBlock(), _createElementBlock("div", _hoisted_2, [!__props.multi ? (_openBlock(), _createElementBlock("strong", _hoisted_3, _toDisplayString(_unref(selectedOption)[__props.textKey]), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedOption), function (option, index) {
        return _openBlock(), _createBlock(_component_PBBadge, {
          key: index,
          close: "",
          label: "",
          bordered: "",
          onClose: function onClose($event) {
            return setSelectedOption(option);
          }
        }, {
          "default": _withCtx(function () {
            return [_createTextVNode(_toDisplayString(option[__props.textKey]), 1)];
          }),
          _: 2
        }, 1032, ["onClose"]);
      }), 128))]))]))], 64))], 2), _unref(selectedOption) && (_unref(selectedOption).options || _unref(selectedOption).nested) && _unref(isDropdown) ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        "class": "absolute top-1/2 -translate-y-1/2 min-w-[30px] min-h-[40px] right-[2px] flex items-center justify-center",
        onClick: _withModifiers(goBack, ["stop"])
      }, [_createVNode(_component_PBIcon, {
        name: "close",
        w: 12,
        h: 12
      })], 8, _hoisted_5)) : (_openBlock(), _createBlock(_component_PBIcon, {
        key: 2,
        "class": "PBSelect__trigger-icon PBSelect__trigger-icon--chevron pointer-events-none",
        name: "chevron",
        w: 12,
        h: 7
      }))], 2), _renderSlot(_ctx.$slots, "footer"), _withDirectives(_createElementVNode("div", {
        "class": "PBSelect__error"
      }, _toDisplayString(__props.error), 513), [[_vShow, __props.error]]), _withDirectives(_createElementVNode("div", _hoisted_6, [_unref(groups).length ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("button", {
        ref: "prevButton",
        "class": "PBSelect__control PBSelect__control--prev",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return scroll('left');
        })
      }, [_createVNode(_component_PBIcon, {
        name: "chevron",
        w: 12,
        h: 7
      })], 512), _createElementVNode("div", null, [_createElementVNode("ul", {
        ref_key: "selectTabsRef",
        ref: selectTabsRef
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groups), function (group, index) {
        return _openBlock(), _createElementBlock("li", {
          key: index
        }, [_createElementVNode("a", {
          href: "#",
          "class": _normalizeClass({
            active: _unref(selectedGroup) === group
          }),
          onClick: _withModifiers(function ($event) {
            return selectTab($event, group);
          }, ["prevent"])
        }, _toDisplayString(group), 11, _hoisted_8)]);
      }), 128))], 512)]), _createElementVNode("button", {
        ref: "nextButton",
        "class": "PBSelect__control PBSelect__control--next",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return scroll('right');
        })
      }, [_createVNode(_component_PBIcon, {
        name: "chevron",
        w: 12,
        h: 7
      })], 512)])) : _createCommentVNode("", true), _ctx.$slots['dropdown-head'] ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_renderSlot(_ctx.$slots, "dropdown-head")])) : _createCommentVNode("", true), __props.showSearch && __props.options.length > 5 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_withDirectives(_createElementVNode("input", {
        ref_key: "searchInputRef",
        ref: searchInputRef,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return _isRef(searchQuery) ? searchQuery.value = $event : null;
        }),
        type: "text",
        placeholder: "Search",
        "class": "test-select-search"
      }, null, 512), [[_vModelText, _unref(searchQuery)]]), _createVNode(_component_PBIcon, {
        "class": "PBSelect__search-icon",
        name: "search",
        w: 14,
        h: 14
      })])) : _createCommentVNode("", true), _createElementVNode("div", null, [__props.topListTitle && _unref(filteredTopList).length ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(__props.topListTitle), 1)) : _createCommentVNode("", true), _unref(filteredTopList).length > 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredTopList), function (option, index) {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          "class": _normalizeClass({
            active: isActive(option)
          }),
          onClick: _withModifiers(function ($event) {
            return selectOption(option);
          }, ["stop"])
        }, [_createElementVNode("div", null, [_ctx.$slots['nested-option'] && option.nested ? _renderSlot(_ctx.$slots, "nested-option", {
          key: 0,
          option: option
        }) : _ctx.$slots.option ? _renderSlot(_ctx.$slots, "option", {
          key: 1,
          option: option
        }) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [_createTextVNode(_toDisplayString(option[__props.textKey]), 1)], 64))])], 10, _hoisted_13);
      }), 128))])) : _createCommentVNode("", true), __props.topListTitle && __props.topList.length ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Other ")) : _createCommentVNode("", true), _unref(filteredOptions).length > 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredOptions), function (option, index) {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          "class": _normalizeClass({
            active: isActive(option),
            'option-disabled': __props.disabledOption(option)
          }),
          onClick: _withModifiers(function ($event) {
            return selectOption(option);
          }, ["stop"])
        }, [_createElementVNode("div", null, [_ctx.$slots['nested-option'] && option.nested ? _renderSlot(_ctx.$slots, "nested-option", {
          key: 0,
          option: option
        }) : _ctx.$slots.option ? _renderSlot(_ctx.$slots, "option", {
          key: 1,
          option: option
        }) : (_openBlock(), _createElementBlock("div", _hoisted_17, [_createTextVNode(_toDisplayString(option[__props.textKey]) + " ", 1), __props.multi && isActive(option) ? (_openBlock(), _createBlock(_component_PBIcon, {
          key: 0,
          name: "check",
          w: 16,
          h: 12,
          "class": "ml-auto"
        })) : _createCommentVNode("", true)]))])], 10, _hoisted_16);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_18, " No data "))])], 512), [[_vShow, _unref(isDropdown)]])], 2);
    };
  }
};